define([
	"dojo/_base/declare",
	"csi/heading/Ref"
], function(declare,Ref) {
	
	return declare(Ref, {
		getNodeDisplayName: function(/*Context*/ctx, /*Node*/node) {
			// summary: return parent name of GeneratedFor node
			node = ctx.cache.getNode(node.__Parent__);
			return this.inherited(arguments, [ctx, node]);
		}
	});
});